import Modal from './modal';
import {usePageText} from '../context/page-text-context';
import {useRepair} from '../context/repair-context';
import {ConfirmButtonFilled} from './buttons';

const SchedulingMessageModal = ({
  modalOpen,
  setModalOpen,
}: {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
}) => {
  const {
    dynamicContent: {schedulingDisabledMessageHeader, schedulingDisabledMessageBody},
  } = useRepair();
  const {closeButton} = usePageText();
  return (
    <Modal visible={modalOpen} showCloseButton={false}>
      <div
        className="flex flex-col items-center gap-4 max-w-[90vw] md:w-[500px] text-black"
        data-testid="schedule-disabled">
        <h1 className="font-bold text-2xl text-center">{schedulingDisabledMessageHeader}</h1>
        <p className="font-semibold pl-2">{schedulingDisabledMessageBody}</p>

        <div className="w-1/2">
          <ConfirmButtonFilled onClick={() => setModalOpen(false)}>{closeButton}</ConfirmButtonFilled>
        </div>
      </div>
    </Modal>
  );
};

export default SchedulingMessageModal;
